module.exports = __webpack_public_path__ + "img/serene_logo.ba784693.png";